import { SharedConstants } from "../../../../constants/shared.constants";
export class AttachmentManagerConstants {
    static ATTACHMENT_TYPE_CTRL = "attachmentType";
    static ATTACHMENT_TYPE_LBL = "Attachment type";
    static DESCRIPTION_CTRL = "description";
    static DESCRIPTION_LBL = "Description";
    static UPLOADED_BY_NAME = "uploadedByName";
    static MODULE_ID = "moduleId";
    static APP_ID = "appId";
    static UPLOADED_BY_ID = "uploadedById";
    static ATTACHMENT_FORM_GROUP = "attachmentFormGroup";
    static FILE_NAME_CTRL = "fileName";
    static FILESIZE_CTRL = "fileSize";
    static FILES_CTRL = "file";
    static COMPONENT_TYPE_CTRL = "componentType";
    static FILE_LBL = "File";
    static DOWNLOAD_LBL = "Download";
    static TITLE_LBL = "Add attachment";
    static COMPONENT_TYPE_DEFAULT_NAME = "Ad Hoc";
    static ATTACHMENT_MANAGER_COMPONENT = "Attachment Manager component";
    static ADD_ATTACHMENT_COMPONENT = "Add Attachment component";
    static MAXIMUM_CHARACTERS = 500;
    static ATTACHMENT_LIST_FORM_CTRL = "attachmentListForm";
    static ATTACHMENT_ARRAY = "attachmenArray";
    static ATTACHMENT_LIST_CTRL = "attachmentList";
    static MAX_LENGTH = SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", AttachmentManagerConstants.MAXIMUM_CHARACTERS.toString());
    static EXISTING_ATTACHMENT = "already selected.";
    // CONFIRMATIONS
    static DELETE_REPORT_CONFIRM = SharedConstants.REMOVE_MESSAGE + " attachment(s)?";
    static DELETE_ATTACHMENT_TITLE = "Delete attachment";
    // Selected Attachments
    static SELECT_ATTACHMENT_CTRL = "Select attachment";
    static SELECT_ATTACHMENT_ERROR = `Attachment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`;
    static ANONYMOUS_ACCESS_MESSAGE = "Anonymous document access is enabled. The attachments will only be available when opening the link in the email and will not be attached in the email. Please ensure that you select which documents you want the user to see by checking the checkbox in the 'Anonymous access' column within the table below after adding then into the table below.";
}
